import { render, staticRenderFns } from "./sidebar-arrow.vue?vue&type=template&id=a89818b8&scoped=true"
var script = {}
import style0 from "./sidebar-arrow.vue?vue&type=style&index=0&id=a89818b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89818b8",
  null
  
)

export default component.exports